import { axiosInstance } from "./axiosInstance";

export const productService = {
    getProduct: async ( filters ) => {
        return await axiosInstance.get('/api/superadmin/product', { params: filters })
    },
    createProduct: async (data) => {
        return await axiosInstance.post('/api/superadmin/product/create', data)
    },
    updateProduct: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/product/update/${id}`, data)
    },
    deleteProduct: async (id) => {
        return await axiosInstance.delete(`/api/superadmin/product/delete/${id}`)
    },
}